module.exports = __webpack_public_path__ + "static/media/Ruby_example.67710511.zip";